import gql from 'graphql-tag';

/**
 * GQL Update Preventive Maintenance Schedule Mutation
 */

export const updatePMScheduleMutation = gql(/* GraphQL */ `
  mutation updatePMScheduleMutation($updatePMSchedule: UpdatePMScheduleDTO!) {
    updatePMSchedule(schedule: $updatePMSchedule) {
      scheduleId
      updatedAt
    }
  }
`);
